import Api from "./api";

class FavoriteService {
    api = new Api();

    addToFavorite(ancestorId, attributes) {
        return this.api.post('/buyer/favorite/add-to-favorite', {
            ancestorId: ancestorId,
            attributeValues: attributes
        });
    }

    isFavoriteAttributes(ancestorId, attributes) {
        return this.api.post('/buyer/favorite/get-favorite', {
            ancestorId: ancestorId,
            attributeValues: attributes
        });
    }

    getFavorites() {
        return this.api.post('/buyer/favorite/get-favorites');
    }


    getFavoriteById(favoriteId) {
        return this.api.post('/buyer/favorite/get-favorite-by-id', {
            favoriteId: favoriteId
        });
    }

    getFavoriteTitle(itemId, attributes) {
        return this.api.post('/buyer/favorite/get-favorite-title', {
            itemId: itemId,
            attributes: attributes
        });
    }

    removeFavorite(favoriteId) {
        return this.api.post('/buyer/favorite/remove-favorite', {
            favoriteId: favoriteId
        });
    }
}

export default new FavoriteService();